module.exports = __webpack_public_path__ + "static/media/SentinelX_logo_lightAlt.44fb1861.png";